import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

export default function HelpTooltip({ message, ...props }) {
  return (
    <Tooltip title={message}>
      <Box component="span" {...props}>
        <HelpOutline color="primary" sx={{ fontSize: 16 }} />
      </Box>
    </Tooltip>
  );
}
